import { render, staticRenderFns } from "./ItsBaseBrand.vue?vue&type=template&id=52a33298&scoped=true&"
import script from "./ItsBaseBrand.vue?vue&type=script&lang=js&"
export * from "./ItsBaseBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a33298",
  null
  
)

export default component.exports